const initialState = {
  sideBar: false,
  cameras: null,
  editInfo: null,
  dblClicked: null,
  add_camera_done: false,
  side_bar_cameras: [],
  onMapCamerasView: null
}

const cameraSideBar = (state = initialState, action) => {
  switch (action.type) {
    case "CAMERA_SIDEBAR_OPEN":
      return { ...state, sideBar: action.val }
    case "CAMERA_SIDEBAR_ADD_CAMERA":
      return { ...state, cameras: action.val }
    case "CAMERA_SIDEBAR_OPEN_EDIT_INFO":
      return { ...state, editInfo: action.val }
    case "CAMERA_SIDEBAR_DBLCLICKED_DATA":
      return { ...state, dblClicked: action.val }
    case "CAMERA_ADD_DONE":
      return { ...state, add_camera_done: action.val }
    case "CAMERA_ADD_TO_SIDEBAR":
      return { ...state, side_bar_cameras: action.val }
    case "CAMERA_MAP_VIEW":
      return { ...state, onMapCamerasView: action.val }
    default:
      return state
  }
}

export default cameraSideBar
